<template>
    <div class="page-content header-clear-medium">
		
		<div class="card card-style overflow-visible" style="height: 720px;">
			<iframe :src="`https://man3bwi.sch.id/agenda/${$route.params.slug}`" title="" style="height: 100%;">
			</iframe>
		</div>
        
    </div>
</template>

<script>
export default {
    name: 'EventPageSingle',
    data() {
        return {

        }
    },
    async created() {

    },
    methods: {
        
    },
    computed: {
        
    }
}
</script>

<style scoped>
body {
	overflow: hidden;
}
</style>
